<script setup>

const props = defineProps()
const opened = defineModel({required: true, default: false})
</script>

<template>
  <div v-if="opened">
    <Teleport to="body">
      <div class="def-modal">
        <div class="def-modal__overlay" @click="$emit('close'); opened=false"></div>
        <transition>
          <div class="def-modal__body">
            <div class="def-modal__close" @click="$emit('close'); opened=false">
              <svg>
                <use xlink:href="#svg-close"></use>
              </svg>
            </div>
            <slot></slot>
          </div>
        </transition>
      </div>
    </Teleport>
  </div>
</template>

<style scoped lang="scss">
@keyframes fade {
  from {opacity: 0;}
  to {opacity: 1;}
}
.def-modal {
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 999;
    opacity: 1;
  }

  &__body {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 3px;
    background-color: #fff;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    width: 100%;
    max-width: 1000px;
    z-index: 1000;
    max-height: 70vh;
    overflow: auto;
    animation: fade .3s forwards;
  }

  &__close {
    display: flex;
    cursor: pointer;
    position: absolute;
    top: 8px;
    right: 8px;
    z-index: 1;
    width: 20px;
    height: 20px;
  }
}
</style>